// A2F-766: liquid top nav for the authed plugin pages.
//
// Replaces the A2F-619 fixed-width Nav with a fluid layout that scales
// cleanly between 1280–1920px. No hard breakpoints below xl. Four nav
// items unchanged: Configure / Install / Account / Sign out (auth) or
// Pricing / Install / Sign in (anon). Design tokens match v2's
// ProV2Header so the editor and signup surfaces feel like one product.

import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'
import logoUrl from '../../../assets/icon-80.png?url'

export function Nav() {
  const { session, signOut } = useAuth()
  const { pathname } = useLocation()

  const linkCls = (path: string) =>
    `text-[13px] font-medium transition-colors ${
      pathname === path
        ? 'text-brand-orange'
        : 'text-brand-charcoal hover:text-brand-orange'
    }`

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto w-full max-w-[1600px] px-6 lg:px-8 h-14 flex items-center justify-between gap-6">
        <Link
          to={session ? '/configure' : '/'}
          className="flex items-center gap-2.5 shrink-0"
        >
          <img src={logoUrl} alt="" className="h-7 w-7 object-contain" />
          <span className="font-bold text-sm text-brand-charcoal tracking-wide">
            CHRONA
          </span>
          <span className="text-[10px] font-semibold text-brand-orange tracking-[0.18em] uppercase border-l border-slate-200 pl-2.5">
            Configurator · Pro
          </span>
        </Link>

        <nav className="flex items-center gap-5 lg:gap-7 min-w-0">
          {session ? (
            <>
              <Link to="/configure" className={linkCls('/configure')}>
                Configure
              </Link>
              <Link to="/install" className={linkCls('/install')}>
                Install
              </Link>
              <Link to="/account" className={linkCls('/account')}>
                Account
              </Link>
              <button
                type="button"
                onClick={() => void signOut()}
                className="text-[13px] font-medium text-slate-500 hover:text-slate-700 transition-colors"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/pricing" className={linkCls('/pricing')}>
                Pricing
              </Link>
              <Link to="/install" className={linkCls('/install')}>
                Install
              </Link>
              <Link
                to="/configure"
                className="text-[13px] font-medium text-brand-orange hover:text-brand-orange/80 transition-colors"
              >
                Sign in →
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  )
}
